import { getDataAPI } from '../utils/fetchData';

// Get overall analytics summary
export const getAnalyticsSummary = async (token) => {
  try {
    const response = await getDataAPI('analytics/summary', token);
    return response;
  } catch (error) {
    console.error('Error fetching analytics summary:', error);
    throw error;
  }
};

// Get experts analytics
export const getExpertsAnalytics = async (token, filter = 'week') => {
  try {
    const response = await getDataAPI(`analytics/experts?filter=${filter}`, token);
    return response;
  } catch (error) {
    console.error('Error fetching experts analytics:', error);
    throw error;
  }
};

// Get bookings analytics
export const getBookingsAnalytics = async (token, filter = 'week') => {
  try {
    const response = await getDataAPI(`analytics/bookings?filter=${filter}`, token);
    return response;
  } catch (error) {
    console.error('Error fetching bookings analytics:', error);
    throw error;
  }
};

// Get catalog analytics
export const getCatalogAnalytics = async (token, filter = 'week') => {
  try {
    const response = await getDataAPI(`analytics/catalog?filter=${filter}`, token);
    return response;
  } catch (error) {
    console.error('Error fetching catalog analytics:', error);
    throw error;
  }
};

// Get merch analytics
export const getMerchAnalytics = async (token, filter = 'week') => {
  try {
    const response = await getDataAPI(`analytics/merch?filter=${filter}`, token);
    return response;
  } catch (error) {
    console.error('Error fetching merch analytics:', error);
    throw error;
  }
};

// Get pages analytics
export const getPagesAnalytics = async (token, filter = 'week') => {
  try {
    const response = await getDataAPI(`analytics/pages?filter=${filter}`, token);
    return response;
  } catch (error) {
    console.error('Error fetching pages analytics:', error);
    throw error;
  }
};

// Export analytics data
export const exportAnalyticsData = async (token, category, format = 'csv') => {
  try {
    const response = await getDataAPI(`analytics/export?category=${category}&format=${format}`, token);
    return response;
  } catch (error) {
    console.error('Error exporting analytics data:', error);
    throw error;
  }
}; 